import React from 'react';
import { createLogger } from '../utils/logger';

const log = createLogger('ErrorBoundary');

/**
 * ErrorBoundary — catches unhandled rendering errors, logs structured
 * diagnostics, and shows a user-friendly fallback with request_id + retry.
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ errorInfo });
    log.error('react_render_error', {
      message: error?.message,
      stack: error?.stack,
      componentStack: errorInfo?.componentStack,
    });
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null, errorInfo: null });
  };

  render() {
    if (this.state.hasError) {
      const errorMsg = this.state.error?.message || 'An unexpected error occurred.';
      const requestId = this.state.error?.request_id;

      return (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '200px',
          padding: '2rem',
          textAlign: 'center',
          color: 'var(--text-primary, #333)',
        }}>
          <h2 style={{ marginBottom: '0.5rem' }}>Something went wrong</h2>
          <p style={{ marginBottom: '1rem', color: 'var(--text-muted, #888)' }}>
            {errorMsg}
          </p>
          {requestId && (
            <p style={{ fontSize: '0.8rem', color: 'var(--text-muted, #888)', marginBottom: '1rem' }}>
              Request ID: <code>{requestId}</code>
            </p>
          )}
          <button
            onClick={this.handleRetry}
            style={{
              padding: '0.5rem 1.5rem',
              borderRadius: '4px',
              border: '1px solid var(--border, #ccc)',
              background: 'var(--surface, #fff)',
              cursor: 'pointer',
            }}
          >
            Try Again
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}
